import React from "react";
import { useLocation } from "react-router-dom";

interface NavbarLinkProps {
    text: string; // The text to display for the link
    onClick: () => void; // The routing function to execute when the link is clicked
    isActivePath?: string[]; // The path to check if the link is active
    notificationBatch?: boolean;
    mode?: 'dark' | 'light'; // The color mode for the link
}

const NavbarLink: React.FC<NavbarLinkProps> = ({ 
    text, 
    onClick, 
    isActivePath, 
    notificationBatch = false,
    mode = 'light' // Default to light mode
}) => {
    const location = useLocation();

    // Check if the current path matches the active path
    const isActive = isActivePath && isActivePath.some(path => location.pathname.includes(path));

    // Define color classes based on mode
    const activeClasses = mode === 'dark' 
        ? "border-secondary-100 text-secondary-100" 
        : "border-primary-500 text-gray-900";
    
    const inactiveClasses = mode === 'dark'
        ? "border-transparent text-white hover:border-white hover:text-white"
        : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700";

    return (
        <div
            onClick={onClick}
            className={`inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium cursor-pointer
                ${isActive ? activeClasses : inactiveClasses}`}
        >
            {text}
            {notificationBatch && (
                <div className={`ml-2 h-2 w-2 rounded-full ${mode === 'dark' ? 'bg-primary-400' : 'bg-primary-500'}`} />
            )}
        </div>
        // <button
        //     onClick={onClick}
        //     className={`relative px-4 py-2 text-sm font-medium transition-colors duration-200 
        //         ${isActive
        //             ? "text-primary dark:text-dark-primary after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-[2px] after:bg-primary dark:after:bg-dark-primary"
        //             : "text-text1 dark:text-dark-text1 hover:text-primary dark:hover:text-dark-primary"
        //         }`}
        // >
        //     <div className="flex items-center">
        //         {text}
        //         {notificationBatch && <div className="ml-2 h-2 w-2 bg-accent dark:bg-dark-accent rounded-full" />}
        //     </div>

        // </button>
    );
};

export default NavbarLink;